import React from 'react';
import {cn} from '@/lib/utils';
import {Typography} from '@/components/ui/typography';
import {Button} from '@/components/ui/button';
import {Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle} from '@/components/ui/card';

type GiveFeedbackCtaProps = {
    className?: string;
    title?: string;
    subtitle?: string;
    ctaText?: string;
    ctaBefore?: React.ReactNode;
    onClick?: () => void;
}

const GiveFeedbackCta = ({
    onClick,
    className,
    title = 'What do you think about this?',
    subtitle = '',
    ctaText = 'Give feedback',
    ctaBefore,
}: GiveFeedbackCtaProps) => {
    return (
        <Card className={cn('border-0 bg-teal-100 relative', className)}>
            <CardHeader>
                <CardTitle>
                    {title}
                </CardTitle>
                <CardDescription>
                    {subtitle}
                </CardDescription>
            </CardHeader>
            <CardContent>
                {ctaBefore}
            </CardContent>
            <CardFooter>
                {ctaText && onClick ? (
                    <Button variant="outline" onClick={onClick}>
                        {ctaText}
                    </Button>
                ) : null}
            </CardFooter>
        </Card>
    )
}

export default GiveFeedbackCta;
